





































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../lib/util";
import appconst from "../lib/appconst";
import AbpBase from "../lib/abpbase";
import Ajax from "../lib/ajax";

interface IRequestParams {
  pictureType: string;
}

@Component({
  components: {}
})
export default class SinglePicture extends AbpBase {
  @Prop({ type: String, default: "" }) value: string;

  @Prop({ type: Object }) requestData: IRequestParams;

  uploadList: Array<any> = new Array<any>();

  visible: boolean = false;

  uploadUrl: string = appconst.excelDownloadUrl + "Picture/UploadPicture";

  get imageUrl() {
    console.log(this.value,'value')
    if (this.value && this.value.length>0) {
      return appconst.remoteServiceBaseUrl + this.value;
    } else {
      return "";
    }
    
  }

  handleView(file) {
    this.visible = true;
  }
  handleRemove(file) {
    // TODO: 删除图片
    let deleteUrl =
      appconst.excelDownloadUrl +
      "Picture/DeletePicture?PictureUrl=" +
      this.value;
    Ajax.get(deleteUrl)
      .then(() => {
        const fileList = (this.$refs.upload as any).fileList;
        (this.$refs.upload as any).fileList.splice(fileList.indexOf(file), 1);
        this.$emit("input","");
      })
      .catch(() => {
        this.$Message.error("删除图片失败");
      });
  }
  handleSuccess(res, file) {
    file.url = appconst.remoteServiceBaseUrl + res.result.url;
    //this.value = res.result.url;
    file.name = res.result.fileName;
    this.$emit("input", res.result.url);
  }
  handleBeforeUpload() {
    if (!!window.abp.auth.getToken()) {
      (this.$refs.upload as any).headers["Authorization"] =
        "Bearer " + window.abp.auth.getToken();
    }
    (this.$refs.upload as any).headers[
      ".AspNetCore.Culture"
    ] = window.abp.utils.getCookieValue("Abp.Localization.CultureName");
    (this.$refs.upload as any).headers[
      "Abp.TenantId"
    ] = window.abp.multiTenancy.getTenantIdCookie();
  }
  mounted() {
    this.uploadList = (this.$refs.upload as any).fileList;
  }
  created(){
  }
  @Watch('value')
  onValueChange(val:string,oldVal:string){
    if((val && val !=='') && this.uploadList.length==0){
      this.uploadList.push({name:'ArticleImage',url: appconst.remoteServiceBaseUrl + this.value, status: 'finished'})
    } else if(!val) {
      this.uploadList = [];
    }
  }
}
